<template>
  <nav-bar title="编辑任务钢瓶" />
  <Content :bottom="0">
    <component
      :is="Edit"
      :data="data"
      :formCols="formCols"
      :step="step"
      @success="onSuccess"
    >
    </component>
    <div v-if="step === 2 || step === 1" style="margin: 16px" @click="step--">
      <van-button round block type="primary"> 上一步 </van-button>
    </div>
    <div v-if="step === 0 || step === 1" style="margin: 16px" @click="step++">
      <van-button round block type="primary"> 下一步 </van-button>
    </div>
  </Content>
</template>

<script setup>
import { defineProps, ref, computed } from 'vue'
import Edit from './components/Edit.vue'
import {
  getCyEthyneCheckInfoMess,
  getCyCheckInfoMess,
  fromOption
} from '@/api/cylinderManageUserHome'
/**
 * 参数
 */
const props = defineProps(['data'])
const arr = props.data.split('-')
const cid = arr[0]
const cMedium = arr[1]
/**
 * 气瓶数据
 */
const data = ref({})
const initData = () => {
  console.log(cMedium)
  if (cMedium === '1') {
    getCyEthyneCheckInfoMess({ cid }).then((res) => {
      data.value = {
        ...res.data,
        cMedium
      }
    })
  }
  if (cMedium === '2') {
    getCyCheckInfoMess({ cid }).then((res) => {
      data.value = {
        ...res.data,
        cMedium
      }
    })
  }
}
initData()
/**
 * 选项数据
 */
const options = ref({})
const getFromOption = () => {
  fromOption({}).then((res) => {
    console.log(res)
    options.value = res.data
  })
}
getFromOption()
/**
 * 编辑步骤数据
 */
const step = ref(0)
const fromData = computed(() => {
  const res = {
    1: [
      // step: 1
      [
        {
          label: '下次检验时间',
          prop: 'nextCheckDate',
          formType: 'date'
        },
        {
          label: '实重kg',
          prop: 'actualWeight',
          formType: 'number'
        },
        {
          label: '外观：裂纹',
          prop: 'appFlawName',
          formProp: 'appFlaw',
          formType: 'radio',
          columns: options.value.checkOption
        },
        {
          label: '外观：划伤',
          prop: 'appScratchName',
          formProp: 'appScratch',
          formType: 'radio',
          columns: options.value.checkOption
        },
        {
          label: '外观：凹陷',
          prop: 'appConcavityName',
          formProp: 'appConcavity',
          formType: 'radio',
          columns: options.value.checkOption
        },
        {
          label: '外观：鼓包',
          prop: 'appSwellingName',
          formProp: 'appSwelling',
          formType: 'radio',
          columns: options.value.checkOption
        },
        {
          label: '外观：烧伤',
          prop: 'appBurnName',
          formProp: 'appBurn',
          formType: 'radio',
          columns: options.value.checkOption
        },
        {
          label: '腐蚀: 点',
          prop: 'appCorrosionSpotName',
          formProp: 'appCorrosionSpot',
          formType: 'radio',
          columns: options.value.checkOption
        },
        {
          label: '腐蚀: 线',
          prop: 'appCorrosionLineName',
          formProp: 'appCorrosionLine',
          formType: 'radio',
          columns: options.value.checkOption
        },
        {
          label: '腐蚀: 大面积',
          prop: 'appCorrosionAreaName',
          formProp: 'appCorrosionArea',
          formType: 'radio',
          columns: options.value.checkOption
        }
      ],
      // step: 2
      [
        {
          label: '焊缝',
          prop: 'weldingSeamName',
          formProp: 'weldingSeam',
          formType: 'radio',
          columns: options.value.checkAir
        },
        {
          label: '塞座',
          prop: 'plugSeatName',
          formProp: 'plugSeat',
          formType: 'radio',
          columns: options.value.checkAir
        },
        {
          label: '阀座',
          prop: 'valveSeatName',
          formProp: 'valveSeat',
          formType: 'radio',
          columns: options.value.checkAir
        },
        {
          label: '填料：裂缝溃散',
          prop: 'crackScatterName',
          formProp: 'crackScatter',
          formType: 'radio',
          columns: options.value.checkOption
        },
        {
          label: '填料：火焰反击',
          prop: 'flameBackName',
          formProp: 'flameBack',
          formType: 'radio',
          columns: options.value.checkOption
        },
        {
          label: '填料：疏松柔软',
          prop: 'looseSoftName',
          formProp: 'looseSoft',
          formType: 'radio',
          columns: options.value.checkOption
        },
        {
          label: '间隙/mm: 径向',
          prop: 'gapRadial',
          formType: 'number'
        },
        {
          label: '间隙/mm: 轴向',
          prop: 'gapAxial',
          formType: 'number'
        }
      ],
      // step: 3
      [
        {
          label: '壁厚/mm： 上封头',
          prop: 'thickUpperHead',
          formType: 'number'
        },
        {
          label: '壁厚/mm：下封头',
          prop: 'thickLowerHead',
          formType: 'number'
        },
        {
          label: '壁厚/mm：筒体',
          prop: 'thickCylinder',
          formType: 'number'
        },
        {
          label: '附件: 瓶阀',
          prop: 'bottleValveName',
          formProp: 'bottleValve',
          formType: 'radio',
          columns: options.value.checkAir
        },
        {
          label: '附件: 易熔塞',
          prop: 'fusiblePlugName',
          formProp: 'fusiblePlug',
          formType: 'radio',
          columns: options.value.checkAir
        },
        {
          label: '附件: 瓶帽',
          prop: 'capsuleName',
          formProp: 'capsule',
          formType: 'radio',
          columns: options.value.checkAir
        },
        {
          label: '附件: 标记环',
          prop: 'markIngName',
          formProp: 'markIng',
          formType: 'radio',
          columns: options.value.checkAir
        },
        {
          label: '改正皮重/kg',
          prop: 'tareWeight',
          formType: 'number'
        },
        {
          label: '气密性试验',
          prop: 'airTightName',
          formProp: 'airTight',
          formType: 'radio',
          columns: options.value.checkAir
        },
        {
          label: '评定结论',
          prop: 'resultName',
          formProp: 'result',
          formType: 'radio',
          columns: options.value.checkResult
        },
        {
          label: '履历表编号',
          prop: 'resumeNo',
          formType: 'text'
        }
      ]
    ],
    2: [
      // step: 1
      [
        {
          label: '公称工作压力MPa',
          prop: 'nomiPressure',
          formType: 'text'
        },
        {
          label: '上次检验日期',
          prop: 'lastCheckDate',
          formType: 'date'
        },
        {
          label: '下次检验日期',
          prop: 'nextCheckDate',
          formType: 'date'
        },
        {
          label: '机械损伤',
          prop: 'appMecDamageName',
          formProp: 'appMecDamage',
          formType: 'radio',
          columns: options.value.checkOption
        },
        {
          label: '热损伤',
          prop: 'appTherDamageName',
          formProp: 'appTherDamage',
          formType: 'radio',
          columns: options.value.checkOption
        },
        {
          label: '腐蚀的点或线',
          prop: 'appCorrosionName',
          formProp: 'appCorrosion',
          formType: 'radio',
          columns: options.value.checkOption
        },
        {
          label: '项圈的检查',
          prop: 'appColCheckName',
          formProp: 'appColCheck',
          formType: 'radio',
          columns: options.value.checkOption
        }
      ],
      // step: 1
      [
        {
          label: '音响检查',
          prop: 'audioCheckName',
          formProp: 'audioCheck',
          formType: 'radio',
          columns: options.value.checkAir
        },
        {
          label: '瓶口螺纹',
          prop: 'bottleThreadName',
          formProp: 'bottleThread',
          formType: 'radio',
          columns: options.value.checkAir
        },
        {
          label: '内部检查',
          prop: 'innerCheckName',
          formProp: 'innerCheck',
          formType: 'radio',
          columns: options.value.checkAir
        },
        {
          label: '原始重量kg',
          prop: 'oriWeight',
          formType: 'number'
        },
        {
          label: '现重量kg',
          prop: 'curWeight',
          formType: 'number'
        },
        {
          label: '带水重量kg',
          prop: 'waterWeight',
          formType: 'number'
        },
        {
          label: '重量损失率%',
          prop: 'weightLossRate',
          formType: 'number'
        },
        {
          label: '原始容积L',
          prop: 'oriVolume',
          formType: 'number'
        },
        {
          label: '现容积L',
          prop: 'curVolume',
          formType: 'number'
        },
        {
          label: '容积增大率%',
          prop: 'volIncrRate',
          formType: 'number'
        }
      ],
      // step: 3
      [
        {
          label: '试验压力MPa',
          prop: 'testPressure',
          formType: 'text'
        },
        {
          label: '保压时间S',
          prop: 'holdTime',
          formType: 'number'
        },
        {
          label: '全变形值ml',
          prop: 'totalDeform',
          formType: 'text'
        },
        {
          label: '参与变形值ml',
          prop: 'resiDeform',
          formType: 'text'
        },
        {
          label: '参与变形率(%)',
          prop: 'resiDeformRate',
          formType: 'number'
        },
        {
          label: '气密性试验',
          prop: 'airTightName',
          formProp: 'airTight',
          formType: 'radio',
          columns: options.value.checkAir
        },
        {
          label: '检验评定结论',
          prop: 'resultName',
          formProp: 'result',
          formType: 'radio',
          columns: options.value.checkResult
        }
      ]
    ]
  }
  return res
})
const formCols = computed(() => {
  return fromData.value[cMedium][step.value]
})

const onSuccess = (value) => {
  data.value = { ...data.value, ...value }
  if (step.value === 2) return
  step.value++
}
</script>

<style lang="scss" scoped></style>
